import { keyBy } from '@adsk/alloy-react-helpers';

import { RawAsset, Asset, Status, CategoryMetadata } from '../types';

const getParsedAssets = (
  assets: RawAsset[],
  categories: CategoryMetadata[],
  statuses: Status[],
): Asset[] => {
  const categoriesMap = keyBy(categories, 'id');
  const statusesMap = keyBy(statuses, 'id');

  return assets.map((asset) => {
    const category = categoriesMap[asset.categoryId];
    const status = statusesMap[asset.statusId];

    return {
      ...asset,
      ...(category && { category }),
      ...(status && { status }),
    };
  });
};

export default getParsedAssets;
